export enum ShuttleTypes {
  Unknown = 0,
  InTerminal = 1,
  CarRentalShuttleOffAirport = 2,
  CarRentalShuttleInTerminal = 3,
  CarRentalShuttleOnAirport = 4,
  AirportShuttleOnAirport = 5,
  CallForShuttle = 6,
  AirportShuttleThenRentalShuttle = 7,
  NonTerminal = 8,
  OffAirport = 9,
}
